import {ThemeConfig} from '../../types';
import {DayColors, NightColors} from './colors';
import {Radii} from './radii';
import {Spacing} from './spacing';
import {TypographyVariants} from './typography';
import {Borders} from './borders';
import {Devices} from './devices';

export const DefaultThemeConfig: ThemeConfig = {
  colors: {
    day: DayColors,
    night: NightColors,
  },
  spacing: Spacing,
  radii: Radii,
  typography: TypographyVariants,
  borders: Borders,
  devices: Devices,
};
